import { Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import DashboardCard from '/@/components/bayer/dashboard-card';
import BayerTabs from '/@/components/bayer/tabs';
import useUnitProvider from '/@/core/context/unit';
import { useGrowersDashboardReports } from '/@/hooks/dashboards';
import { _ } from '/@/locale';
import { getNodeScopeFilters } from '/@/utils/node-scope';

const HybridRankingReportDashboardCard = ({ year }: { year: number }) => {
    const [currentHybridZone, setCurrentHybridZone] = useState<string | undefined>(undefined);
    const units = useUnitProvider();

    const { data: dashboardReports, isValidating } = useGrowersDashboardReports({
        year,
        ...getNodeScopeFilters('rvs'),
    });

    const parsedYieldByHybrids = dashboardReports?.harvest?.avgYieldByProducts?.reduce(
        (acc, product) => {
            const zone = _(product.zoneShortName);
            if (!acc[zone]) {
                acc[zone] = [];
            }
            acc[zone].push(product);
            return acc;
        },
        {} as Record<string, NonNullable<typeof dashboardReports>['harvest']['avgYieldByProducts']>
    );

    useEffect(() => {
        // Set initial zones if not set
        if (!currentHybridZone && dashboardReports.avaiableZones?.length > 0) {
            setCurrentHybridZone(dashboardReports.avaiableZones[0]!.value);
        }
    }, [currentHybridZone, dashboardReports.avaiableZones]);
    return (
        <DashboardCard
            title={_('Ranking híbridos')}
            subtitle={_('Rendimiento promedio de híbridos')}
            isLoading={isValidating}
            spacing={0.5}
        >
            <Stack direction='column' spacing={2} sx={{ height: 'fill-available', pt: 1.5 }}>
                <BayerTabs
                    value={currentHybridZone}
                    setValue={setCurrentHybridZone}
                    options={
                        dashboardReports.zones?.map((zone) => ({
                            label: zone.value,
                            value: zone.value,
                            disabled: zone.isDisabled,
                            tooltipText: zone.isDisabled ? _('No hay información para esta zona') : '',
                        })) || []
                    }
                    variant='chips'
                />
                <Stack direction='column' spacing={0.5}>
                    {parsedYieldByHybrids?.[currentHybridZone]?.map((product) => (
                        <Stack key={product.productName} direction='row' spacing={2} justifyContent='space-between'>
                            <Typography variant='subtitle1' color='primary'>
                                {product.productName}
                            </Typography>
                            <Typography variant='subtitle1' fontWeight={700} color='primary'>
                                {units.toYield(product.avgYield, 'corn', 0).toString()}
                            </Typography>
                        </Stack>
                    ))}
                </Stack>
            </Stack>
        </DashboardCard>
    );
};

export default HybridRankingReportDashboardCard;
